// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1c7rd","colCheckbox":"styles_colCheckbox__2IuMU"};